<template>
    <v-main>
        <home-cookies />
        <check-org-invite />
        <transition
            :name="accountTransition ? 'account-page' : ''"
            mode="out-in"
            @after-enter="finishAccountTransition"
        >
            <router-view :key="$route.fullPath" />
        </transition>
    </v-main>
</template>

<script>
export default {
    name: `BaseView`,
    components: {
        HomeCookies: () => import(`@/layouts/home/cookies`),
        CheckOrgInvite: () => import(`@/components/branches/check_invite`)
    },
    beforeRouteUpdate(to, from, next) {
        this.accountTransition = !!((to.meta && to.meta.accountPage) || (from.meta && from.meta.accountPage))
        next()
    },
    data() {
        return { accountTransition: false }
    },
    methods: {
        finishAccountTransition() {
            this.accountTransition = false
        }
    }
}
</script>

<style scoped>
.account-page-enter-active,
.account-page-leave-active {
    transition: opacity 180ms ease, transform 180ms ease;
}
.account-page-enter {
    opacity: 0;
    transform: translateY(8px);
}
.account-page-leave-to {
    opacity: 0;
    transform: translateY(-5px);
}
@media (prefers-reduced-motion: reduce) {
    .account-page-enter-active,
    .account-page-leave-active {
        transition: none;
    }
}
</style>
